<template>
  <base-dialog
    data-testid="expiredSubscriptionDialog.dialog"
    dialog-id="expiredSubscriptionDialog"
    width="500px"
    :cancelable="true"
    :banner="true"
    :title="'Your subscription expired!'"
    @complete-dialog="subscribe"
    @cancel-dialog="remindLater"
  >
    <template #subHeader>
      <div class="subscription-dialog-subheader">
        <h3>
          <strong>Your access is restricted</strong>
        </h3>
      </div>
    </template>

    <template #content>
      <div class="subscription-dialog-content">
        <p>
          You can't edit and simulate models or generate code without a valid subscription! Your access is restricted to
          viewing and downloading your statecharts. Subscribe now to restore all features.
        </p>
      </div>
    </template>

    <template #footer>
      <div class="subscription-dialog-footer">
        <v-btn class="dialog-button" variant="outlined" color="secondary" @click="remindLater"> Remind me later </v-btn>

        <v-btn-dialog-action-CTA
          class="dialog-button"
          data-testid="expiredSubscriptionDialog.subscribe-button"
          color="primary"
          @click="subscribe"
        >
          Subscribe now
        </v-btn-dialog-action-CTA>
      </div>
    </template>
  </base-dialog>
</template>

<script setup lang="ts">
import BaseDialog from "../shared/BaseDialog.vue";
import { SubscriptionService } from "../Subscription/services/subscription-service";
import { useRouter } from "vue-router";

const emit = defineEmits(["continue"]);
const router = useRouter();

async function subscribe() {
  try {
    const currentRoute = router.currentRoute.value.fullPath || "/home";
    const clientUrl = window.location.origin + currentRoute;
    window.location.href = await SubscriptionService.initiateCheckout(clientUrl);
  } catch (e) {
    // Optionally handle error (e.g., show notification)
  }
  emit("continue");
}

function remindLater() {
  //TODO
  emit("continue");
}
</script>

<style scoped>
.subscription-dialog-subheader {
  text-align: center;
  margin-top: 10px;
}

.subscription-dialog-content {
  padding: 10px;
  font-size: 14px;
  color: #444;
  text-align: center;
}

.subscription-dialog-footer {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  padding: 16px 0;
  gap: 12px;
  width: 100%;
}

.dialog-button {
  flex: 1;
  max-width: 200px;
  min-width: 150px;
}
</style>
